export default __webpack_public_path__ + "static/media/AsanaIcon.64beb20e.png";